import React, { FunctionComponent } from 'react';

import Monitor from '../../shared/Monitor';

import { Submission, SubmissionStatus } from '../../../types/models';

interface Props {
  instanceId: number;
  scenarioId: number;
  submissions: Submission[];
  refresh: () => void;
}

const SubmissionMonitor: FunctionComponent<Props> = ({
  instanceId,
  scenarioId,
  submissions,
  refresh,
}) => {
  // Find the newest submission that is actually still running, rather than
  // the newest submission overall. A newer row that has already reached a
  // terminal status (Finished, Failed, or the CLD-2967/CONC-2
  // PendingResolution) must not suppress monitoring of an older row that is
  // still Queued/Started (D8). A Finished row whose promote the API has not
  // seen yet (PromotePending) counts as running: the monitor's refresh is what
  // brings the list back once the promote is visible. Its single-row response
  // never carries the list-only fields, so it always differs and refreshes.
  const runningSubmissions = submissions.filter(
    (s) =>
      [SubmissionStatus.Queued, SubmissionStatus.Started].includes(s.Status) ||
      (s.Status === SubmissionStatus.Finished && s.PromotePending === true)
  );

  const activeSubmission =
    runningSubmissions.length > 0
      ? runningSubmissions.reduce((s, m) => (s.id >= m.id ? s : m))
      : undefined;

  if (activeSubmission === undefined) {
    return null;
  }

  return (
    <Monitor
      path={`/instances/${instanceId}/scenarios/${scenarioId}/submissions/${activeSubmission.id}`}
      object={activeSubmission}
      onChange={refresh}
    />
  );
};

export default SubmissionMonitor;
